// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-2hZ","content":"styles_content__3LxCT"};